import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Container, Typography, Grid, Button} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Topbar from 'components/Topbar';
import Footer from 'components/Footer';
import FilmsList from 'components/FilmsList';
import CinemaSlider from 'components/CinemaSlider';
import CinemaSliderVod from 'components/CinemaSliderVod';
import GeolocInfo from 'components/GeolocInfo';
import Link from 'components/Link';
import Context from 'utils/Context';

import './Accueil.scss';

const Accueil = () => {
  const {appState, goTo, geoloc, modele} = useContext(Context);

  const [canOpenIndex, setCanOpenIndex] = useState(0);
  const [folded, setFolded] = useState(appState.conf.HOME_SHOWS_FOLDED);

  const {t} = useTranslation();

  const isLoggedIn = !!appState.user.email;

  const filmsOk = geoloc ? modele.films.filter(f => f.local) : [];
  const filmsKo = geoloc ? modele.films.filter(f => !f.local) : modele.films || [];
  const cinemasOk = geoloc ? modele.cinemas.filter(c => c.local) : [];

  return (
    <>
      <Container maxWidth={false}>
        <Topbar />
        <div className="spacer" />
        <Grid item xs={12} align="right">
          {isLoggedIn && (
            <>
              <Link className="accueil-top-link" url="/faq">
                {t('faq')}
              </Link>
              <Button color="primary" variant="outlined" onClick={() => goTo('/mon-compte/seances')}>
                {t('acceder-a-mes-seances')}
              </Button>
            </>
          )}
        </Grid>
        {!isLoggedIn && modele.pages && (
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="rte-content" dangerouslySetInnerHTML={{__html: modele.pages.concept?.content}} />
              </Grid>
            </Grid>
          </Container>
        )}
        <div className="spacer" />
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h2" component="h2" noWrap>
              <span className="grand-titre">{t('a-laffiche')}</span>
            </Typography>
          </Grid>
        </Grid>
        {filmsOk.length > 0 && !!geoloc && (
          <Typography className="blanc" variant="h5" component="h3" noWrap>
            {t('pres-de-chez-vous')}
          </Typography>
        )}
        <div className="spacer" />
        {filmsOk.length > 0 && <CinemaSlider films={filmsOk} cinemas={cinemasOk} />}
        <div className="spacer" />

        <CinemaSliderVod cinemas={modele.cinemas.filter(c => c.nb_vod_film > 0)} />

        {!!geoloc && filmsKo.length > 0 && (
          <Typography className="blanc" variant="h5" component="h3" noWrap>
            {t('hors-de-votre-zone')} &nbsp;
            {folded && (
              <ExpandMoreIcon style={{verticalAlign: 'middle', cursor: 'pointer'}} onClick={() => setFolded(false)} />
            )}
            {!folded && (
              <ExpandLessIcon style={{verticalAlign: 'middle', cursor: 'pointer'}} onClick={() => setFolded(true)} />
            )}
          </Typography>
        )}
        {!folded && (
          <>
            <div className="spacer" />
            {filmsKo.length > 0 && (
              <FilmsList films={filmsKo} onClick={() => setCanOpenIndex(1)} canOpen={canOpenIndex === 1} />
            )}
            {filmsKo.length > 0 && <div className="spacer" />}
          </>
        )}
        <GeolocInfo />
      </Container>
      <Footer />
    </>
  );
};

export default Accueil;
